<template>
  <div class="pa-2 mb-2">
    <h4 class="settings-h4">Client Certificate Identification</h4>
    <div class="wrapper-2 d-flex pa-2 pos-relative" style="min-height: 60px; align-items: end;">
      

      <v-text-field
      label="Specify the certificate Subject for client recognition"

      v-model="organization.certificateSubject"
      style="max-width: 400px"
        class="mx-1 mb-1"
        dense
        height="20px"
        hide-details
      >
      </v-text-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Certification',
  props: {
    organization: Object,
  },
  created() {
    console.log(this.organization)
  }
}
</script>
